import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M10.3529 1V4H13.6471V1H15.6471V4H17.5376L21.6335 7L17.5376 10H15.6471V12.1111H22V18.1111H15.6471V23H13.6471V18.1111H10.3529V23H8.35294V18.1111H6.46243L2.36645 15.1111L6.46243 12.1111H8.35294V10H2V4H8.35294V1H10.3529ZM13.6471 10H10.3529V12.1111H13.6471V10Z"}}]};

const IndicatorFilled = Vue.extend<IconProps>({
  name: 'IndicatorFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'indicator-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default IndicatorFilled;
